<template>
  <div
    :class="'InfoPanel' + ($store.state.infoPanelDeployed ? '' : ' InfoPanel--collapse')"
    :data-panel="$store.state.infoPanelDeployed"
    >
    <div class="InfoPanel__legendDefinitionCtn" v-if="$store.state.activeNavbarItem === 'treaty'">
      <h3 :style="'color:'+$COLORS[4]+';'">{{ words[lang].legendDefinition.MoratoriumLabel }}</h3>
      <p>{{ words[lang].legendDefinition.MoratoriumDescription }}</p>
      <a :href="words[lang].legendDefinition.MoratoriumMoreInfo" target="_blank">{{ words[lang].general.MoreInformation }}</a>
      <h3 :style="'color:'+$COLORS[3]+';'">{{ words[lang].legendDefinition.Op2Label }}</h3>
      <p>{{ words[lang].legendDefinition.Op2Description }}</p>
      <a :href="words[lang].legendDefinition.Op2MoreInfo" target="_blank">{{ words[lang].general.MoreInformation }}</a>
    </div>
    <div class="InfoPanel__legendDefinitionCtn" v-if="activeCountry == null && $store.state.activeNavbarItem === 'status'">
      <h3 :style="'color:'+$COLORS[4]+';'">{{ words[lang].general.Abolitionist }}</h3>
      <p>{{ words[lang].legendDefinition.Abolitionist }}</p>
      <h3 :style="'color:'+$COLORS[3]+';'">{{ words[lang].general.CommonRightAbolitionist }}</h3>
      <p>{{ words[lang].legendDefinition.CommonRightAbolitionist }}</p>
      <h3 :style="'color:'+$COLORS[2]+';'">{{ words[lang].general.Moratoire }}</h3>
      <p>{{ words[lang].legendDefinition.Moratoire }}</p>
      <h3 :style="'color:'+$COLORS[1]+';'">{{ words[lang].general.Retentionist }}</h3>
      <p>{{ words[lang].legendDefinition.Retentionist }}</p>
    </div>
    <div
      class="InfoPanel__countrySheet"
      v-if="activeCountry != null"
      v-show="$store.state.activeNavbarItem !== 'treaty'">
      <div class="InfoPanel__topInfoCtn">
        <div class="InfoPanel__topInfoRowCtn">
          <h2><strong>{{ country }}</strong><span class="InfoPanel__igos"><span v-for="igo in igos" :key="igo" :data-name="$igoPlaces[igo]['igoname'+lang]">{{ igo }}</span></span></h2>
          <span class="InfoPanel__statusTag" :data-status="statusCode">{{ status }}</span>
        </div>
        <img :src="require('@/assets/icons/ecpm_logo_round.svg')" class="InfoPanel__ecpmProject" v-if="ecpmProject">
      </div>
      <VuePerfectScrollbar class="InfoPanel__newsCtn scroll-area" :settings="settings">
        <div class="InfoPanel__dataCtn" v-if="abolitionYear">
          <h3 class="InfoPanel__dataLabel">{{ words[lang].general.AbolitionYear }}</h3>
          <span :class="'InfoPanel__data InfoPanel__data--lastExecution' + (statusCode != '1' ? ' InfoPanel__treatyDate--text' : '')">{{ abolitionYear }}</span>
        </div>
        <div class="InfoPanel__dataCtn" v-if="lastExecutionDate">
          <h3 class="InfoPanel__dataLabel">{{ words[lang].general.LastExecution }}</h3>
          <span :class="'InfoPanel__data InfoPanel__data--lastExecution' + (statusCode != '1' ? ' InfoPanel__treatyDate--text' : '')">
            {{ lastExecutionDate }}
          </span>
        </div>
        <div class="InfoPanel__dataCtn" v-if="executionMethod">
          <h3 class="InfoPanel__dataLabel">{{ words[lang].general.ExecutionMethod }}</h3>
          <span class="InfoPanel__data InfoPanel__data--executionMethod">{{ executionMethod }}</span>
        </div>
        <div class="InfoPanel__dataCtn" v-if="peopleInDeathRow != null">
          <h3 class="InfoPanel__dataLabel">{{ words[lang].general.PeopleDeathRow }} ({{ $peopleInDeathRowDataYear }})</h3>
          <span class="InfoPanel__data InfoPanel__data--peopleDeathRow">
            <img :src="require('@/assets/icons/standing_up_man.svg')">
            <span class="InfoPanel__dataKPI">{{ peopleInDeathRow }}</span>
            <span class="InfoPanel__dataDesc">{{ words[lang].general.Estimated }}</span>
          </span>
        </div>
        <div class="InfoPanel__dataCtn" v-if="executionsNumber != null">
          <h3 class="InfoPanel__dataLabel">{{ words[lang].general.ExecutionsNumber }} ({{ $executionsNumberDataYear }})</h3>
          <span class="InfoPanel__data InfoPanel__data--executionNumber">
            <img :src="require('@/assets/icons/execution.svg')">
            <span class="InfoPanel__dataKPI">{{ executionsNumber }}</span>
          </span>
        </div>
        <div class="InfoPanel__dataCtn" v-if="condemnationsNumber != null">
          <h3 class="InfoPanel__dataLabel">{{ words[lang].general.CondemnationsNumber }} ({{ $condemnationsDataYear }})</h3>
          <span class="InfoPanel__data InfoPanel__data--executionNumber">
            <img :src="require('@/assets/icons/condemnation.svg')">
            <span class="InfoPanel__dataKPI">{{ condemnationsNumber }}</span>
          </span>
        </div>
        <div class="InfoPanel__dataCtn" v-if="homosexuality || terrorism">
          <h3 class="InfoPanel__dataLabel">{{ words[lang].general.SpecificCharge }}</h3>
          <div class="InfoPanel__specificChargeGlobalCtn">
            <div class="InfoPanel__specificChargeCtn">
              <img :src="require('@/assets/icons/terrorism.svg')">
              <span class="InfoPanel__data">{{ words[lang].general.Terrorism }}</span>
            </div>
            <a class="InfoPanel__specificChargeCtn" :href="words[lang].general.LinkHomosexuality" target="_blank" v-if="homosexuality">
              <img :src="require('@/assets/icons/homosexuality.svg')">
              <span class="InfoPanel__data">{{ words[lang].general.Homosexuality }}</span>
            </a>
          </div>
        </div>
        <div class="InfoPanel__treaties">
          <div class="InfoPanel__treatyCtn InfoPanel__dataCtn">
            <h3 class="InfoPanel__dataLabel">{{ words[lang].general.Op2Ratification }}</h3>
            <div class="InfoPanel__treaty">
              <img :src="require('@/assets/icons/ratification.svg')">
              <span :class="'InfoPanel__treatyDate' + (!op2 ? ' InfoPanel__treatyDate--text' : '')">{{ yearOp2 }}</span>
            </div>
          </div>
          <div class="InfoPanel__treatyCtn InfoPanel__dataCtn">
            <h3 class="InfoPanel__dataLabel">{{ words[lang].general.UniversalMoratoriumVote }} ({{ $moratoriumDataYear }})</h3>
            <div class="InfoPanel__treaty">
              <span class="InfoPanel__treatyDate InfoPanel__treatyDate--text" :style="'color:' + moratorium['color']">{{ moratorium['label'] }}</span>
            </div>
          </div>
          <div class="InfoPanel__dataCtn InfoPanel__dataCtn--source" v-if="sources">
            <h3 class="InfoPanel__dataLabel">{{ words[lang].general.Sources }}</h3>
            <div class="InfoPanel__valueCtn">
              <span class="InfoPanel__value">{{ sources }}</span>
            </div>
          </div>
        </div>
        <div class="InfoPanel__framed" v-if="activityDesc || link || document || image">
          <div class="InfoPanel__dataCtn" v-if="activityDesc">
            <h3 class="InfoPanel__dataLabel">{{ words[lang].general.EcpmActions }}</h3>
            <p class="InfoPanel__activityDesc">{{ activityDesc }}</p>
          </div>
          <div class="InfoPanel__dataCtn" v-if="link || document || image">
            <h3 class="InfoPanel__dataLabel">{{ words[lang].general.MoreInfo }}</h3>
            <div class="InfoPanel__moreInfoCtn">
              <div class="InfoPanel__moreInfoLinkCtn" v-if="link">
                <img :src="require('@/assets/icons/link.svg')">
                <a class="InfoPanel__link" :href="link" target="_blank">{{ link }}</a>
              </div>
              <div class="InfoPanel__moreInfoLinkCtn" v-if="document">
                <img :src="require('@/assets/icons/link.svg')">
                <a class="InfoPanel__link" :href="document" target="_blank">{{ document }}</a>
              </div>
              <a :href="image" target="_blank" v-if="image">
                <img class="InfoPanel__img" :src="image">
              </a>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar >
    </div>
  </div>
</template>

<script>

import { words } from '@/constants/lang'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'InfoPanel',
  components: {VuePerfectScrollbar},
  watch: {
    '$store.state.activeCountry': function() {
      let infoPanel = document.querySelector(".InfoPanel");
      infoPanel.removeAttribute("data-active");
      setTimeout(() => {infoPanel.setAttribute("data-active","true")}, 300);
    }
  },
  data: () => ({
    words,
    settings: {
      maxScrollbarLength: 120,
      wheelSpeed: 0.2,
      swipeEasing: true,
      wheelPropagation: false
    }
  }),
  computed: {
    country: function () {
      return this.activeCountry != null ? this.$dataset[this.activeCountry]['placename' + this.lang] : ""
    },
    igos: function () {
      if (this.$dataset[this.activeCountry]['igo'] === undefined) return '';
      return this.$dataset[this.activeCountry]['igo'].split(",").map(function(item) {
        return item.trim();
      });
    },
    lang: function () {
      return this.$store.state.language.lang
    },
    statusCode: function () {
      return this.activeCountry != null ? this.$dataset[this.activeCountry]['status'] : ""
    },
    document: function () {
      return this.getLink('doc');
    },
    link: function () {
      return this.getLink('link');
    },
    image: function () {
      return this.getLink('image');
    },
    moratorium: function () {
      if (this.activeCountry != null) {
        switch (this.$dataset[this.activeCountry]['moratorium' + this.$moratoriumDataYear]) {
          case "Oui":
            return {'label': this.words[this.lang].general.InFavour, 'color': this.$COLORS["Oui"] };
          case "Non":
            return {'label': this.words[this.lang].general.Against, 'color': this.$COLORS["Non"] };
          case "Abstention":
            return {'label': this.words[this.lang].general.Abstention, 'color': this.$COLORS["Abstention"] };
          case "Absent":
            return {'label': this.words[this.lang].general.Absence, 'color': this.$COLORS["Absent"] };
        }
      }
      return '-';
    },
    op2: function () {
      return this.activeCountry != null && this.$dataset[this.activeCountry]['op2'] != null;
    },
    yearOp2: function () {
      return this.activeCountry != null && this.$dataset[this.activeCountry]['op2'] === "x" ? this.$dataset[this.activeCountry]['yearop2'] : this.words[this.lang].general.NotRatified;
    },
    activityDesc: function () {
      if (this.activeCountry != null && this.$dataset[this.activeCountry]['activitydesc' + this.$store.state.language.lang] != null)
        return this.$dataset[this.activeCountry]['activitydesc' + this.$store.state.language.lang];
      else
        return null;
    },
    crc: function () {
      return this.activeCountry != null && this.$dataset[this.activeCountry]['crc'] != null;
    },
    ecpmProject: function () {
      return this.activeCountry != null && this.$dataset[this.activeCountry]['ecpmproject'] === "x";
    },
    homosexuality: function () {
      return this.activeCountry != null && this.$dataset[this.activeCountry]['homosexuality'] === "x";
    },
    terrorism: function () {
      return this.activeCountry != null && this.$dataset[this.activeCountry]['terrorism'] === "x";
    },
    lastExecutionDate: function () {
      return this.activeCountry != null && this.$dataset[this.activeCountry]['lastexecutiondate'] ? this.$dataset[this.activeCountry]['lastexecutiondate'] : null
    },
    sources: function () {
      return this.activeCountry != null && this.$dataset[this.activeCountry]['sources' + this.lang] ? this.$dataset[this.activeCountry]['sources' + this.lang] : null
    },
    executionMethod: function () {
      let executionMethod = "";
      if (this.activeCountry != null) {
        executionMethod += this.$dataset[this.activeCountry]['fusillade'] != null ? this.words[this.lang].executionMethod.Fusillade + ', ' : '';
        executionMethod += this.$dataset[this.activeCountry]['pendaison'] != null ? this.words[this.lang].executionMethod.Pendaison + ', ' : '';
        executionMethod += this.$dataset[this.activeCountry]['lapidation'] != null ? this.words[this.lang].executionMethod.Lapidation + ', ' : '';
        executionMethod += this.$dataset[this.activeCountry]['decapitation'] != null ? this.words[this.lang].executionMethod.Decapitation + ', ' : '';
        executionMethod += this.$dataset[this.activeCountry]['injectionletale'] != null ? this.words[this.lang].executionMethod.InjectionLetale + ', ' : '';
        executionMethod += this.$dataset[this.activeCountry]['chaiseelectrique'] != null ? this.words[this.lang].executionMethod.ChaiseElectrique + ', ' : '';
        executionMethod += this.$dataset[this.activeCountry]['chambregaz'] != null ? this.words[this.lang].executionMethod.ChambreGaz + ', ' : '';
      }
      return (executionMethod !== "" ? executionMethod.slice(0,-2) : false);
    },
    abolitionYear: function () {
      return this.activeCountry != null && this.$dataset[this.activeCountry]['abolitiondate'] ? this.$dataset[this.activeCountry]['abolitiondate'] : null
    },
    peopleInDeathRow: function () {
      let deathId = 'peopleindeathrow' + this.$peopleInDeathRowDataYear;
      return this.activeCountry != null && this.$dataset[this.activeCountry][deathId] != null ? this.$dataset[this.activeCountry][deathId] : null
    },
    executionsNumber: function () {
      let execId = 'executionsnumber' + this.$executionsNumberDataYear;
      return this.activeCountry != null && this.$dataset[this.activeCountry][execId] != null && this.$dataset[this.activeCountry][execId] != "N/A" ? this.$dataset[this.activeCountry][execId] : null
    },
    condemnationsNumber: function () {
      let condId = 'condemnations' + this.$condemnationsDataYear;
      return this.activeCountry != null && this.$dataset[this.activeCountry][condId] != null && this.$dataset[this.activeCountry][condId] != "N/A" ? this.$dataset[this.activeCountry][condId] : null
    },
    moratoriumNumber: function () {
      let condId = 'moratorium' + this.$moratoriumDataYear;
      return this.activeCountry != null && this.$dataset[this.activeCountry][condId] != null && this.$dataset[this.activeCountry][condId] != "N/A" ? this.$dataset[this.activeCountry][condId] : null
    },
    status: function () {
      if (this.activeCountry != null) {
        switch (this.$dataset[this.activeCountry]['status']) {
          case 1:
            return this.words[this.lang].general.Retentionist;
          case 2:
            return this.words[this.lang].general.Moratoire;
          case 3:
            return this.words[this.lang].general.CommonRightAbolitionist;
          case 4:
            return this.words[this.lang].general.Abolitionist;
        }
      }
      return '-';
    },
    activeCountry: function () {
      return this.$store.state.activeCountry
    }
  },
  methods: {
    getLink: function(columnName) {
      if (this.activeCountry != null) {
        let link = "";

        // Search if there is a link for the active lang
        if (this.$dataset[this.activeCountry][columnName + this.$store.state.language.lang] != null)
          link = this.$dataset[this.activeCountry][columnName + this.$store.state.language.lang];

        // If not search if there is one, for the other lang
        if (link == "") {
          let lang = this.$store.state.language.lang === 'en' ? 'fr' : 'en';
          if (this.$dataset[this.activeCountry][columnName + lang] != null)
            link = this.$dataset[this.activeCountry][columnName + lang];
        }

        // Add ECPM website DNS host url to the link
        if (link !== "")
          return link.includes('http') ? link : this.$ECPM_HOST + link;
      }
      return null;
    },
    toggleEcpm: function () {
      this.$store.commit('toggleEcpmAction')
    },

    getRandomArbitrary: function (min, max) {
      return parseInt(Math.random() * (max - min) + min);
    }
  },
}
</script>

<style scoped lang="less">

  @import "../less/_var.less";

  .InfoPanel {
    display: flex;
    flex-flow: row nowrap;
    width: 380px;
    max-width: calc(100% - 10px);
    height: 100%;
    box-sizing: border-box;
    box-shadow: -14px 0 18px -15px rgba(7, 50, 53, 0.25);
    position: absolute;
    z-index: 4;
    top: 0;
    right: 0;
    transition: all 0.3s ease-in-out;
    border-left: solid 1px #ccc;
    box-sizing: border-box;
    flex: 1 1 auto;
    background: linear-gradient(-18deg, white, #fbfbfb 21%, white 21%);
    display: flex;
    flex-flow: column nowrap;

    &.InfoPanel--collapse {
      transform: translateX(100%);
      box-shadow: none;
    }

    .InfoPanel__legendDefinitionCtn {
      margin: 20px;

      h3 {
        text-transform: uppercase;
        margin-bottom: 5px;

        &:not(:first-child) {
          margin-top: 15px;
        }
      }

      p {
        font-weight: 100;
        font-size: 0.9em;
        line-height: 1.3em;
        margin-top: 5px;
        margin-bottom: 5px;
      }

      a {
        font-weight: 400;
        color: #000;
        font-size: 0.9em;
        line-height: 1.3em;
        margin-bottom: 15px;
      }
    }

    .InfoPanel__topInfoCtn {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;

      .InfoPanel__ecpmProject {
        max-height: 60px;
      }
    }

    .InfoPanel__statusTag {
      text-transform: uppercase;
      color: white;
      border-radius: 2px;
      font-size: 1.05em;
      padding: 2px 7px;
      display: inline-flex;
      flex-flow: column;
      align-items: center;
      margin: 0 7px 5px 0;
      font-weight: 100;
      font-family: @font-primary;

      &[data-status="1"] { background: @color-retentionist; }
      &[data-status="2"] { background: @color-moratorium; }
      &[data-status="3"] { background: @color-commonRightAbolitionist; }
      &[data-status="4"] { background: @color-abolitionist; }
    }

    .InfoPanel__framed {
      padding: 15px;
      box-shadow: 0 0 10px rgba(0,0,0,0.15);
      border-radius: 8px;
      background: #fff;

      .InfoPanel__dataCtn:not(:last-child) {
        border-bottom: solid 1px #ddd;
        padding-bottom: 15px;
      }
      .InfoPanel__dataCtn:last-child {
        margin-bottom: 0;
      }
    }

    .InfoPanel__treaties  {
      display: flex;
      flex-flow: column nowrap;
      margin: 7px 0 18px 0;

      .InfoPanel__treatyCtn {
        display: flex;
        flex-flow: column nowrap;
        margin-bottom: 0;
        font-weight: 100;
        font-family: @font-primary;

        &:not(:last-child) {
          padding: 0 0 20px 0;
        }

        .InfoPanel__treaty {
          display: inline-flex;
          flex-flow: row nowrap;
          align-items: center;

          img {
            margin-right: 8px;
            height: 28px;
          }

          .InfoPanel__treatyDate:not(.InfoPanel__treatyDate--text) {
            font-family: @font-primary;
            color: @color-moratorium;
            font-size: 1.85em;
          }
        }
      }
    }

    .InfoPanel__countrySheet > * {
      padding: 8px 18px 18px 18px;

      &:first-child {
        padding-top: 22px;
        padding-bottom: 6px;
      }
    }

    h2 {
      margin: 0 0 8px 0;
      font-weight: 400;
      line-height: .8em;

      strong {
        margin-right: 6px;
        line-height: 1em;
        font-size: 1.3em;
        font-weight: 400;
        font-family: @font-secondary;
      }

      .InfoPanel__igos {
        font-size: 0.5em;
        line-height: .8em;
        color: #bbb;
        display: inline-block;

        > span {
          cursor: default;
          position: relative;

          &::before {
            position: absolute;
            content: attr(data-name);
            bottom: calc(100% + 5px);
            opacity: 0;
            width: max-content;
            right: 0;
            transition: all 150ms ease-in;
            transform: scale(0);
            transform-origin: center bottom;
            display: flex;
            align-items: center;
            padding: 6px 6px 4px 6px;
            line-height: 1em;
            border-radius: 5px;
            border-bottom-right-radius: 0;
            font-weight: 100;
            color: white;
            background: rgba(14, 11, 11, 0.8);
            box-shadow: 0 2px 10px -3px rgba(0, 0, 0, 0.15);
          }
          &:hover {
            font-weight: bold;

            &::before {
              transform: scale(1);
              opacity: 1;
            }
          }

          &:not(:last-child) {
            &::after {
              content: ", ";
            }
          }
        }
      }
    }

    h3 {
      font-family: @font-secondary;
      font-size: 0.9em;
      font-weight: 500;
      margin: 0 0 10px 0;
    }

    .InfoPanel__specificChargeGlobalCtn {
      display: flex;
      flex-flow: row nowrap;
      gap: 2rem;

      .InfoPanel__specificChargeCtn {
        margin-right: 10px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        color: #222;
        text-decoration: none;

        img {
          max-height: 33px;
          margin-right: 8px;
          max-width: 42px;
        }
      }
    }

    .InfoPanel__dataCtn {
      display: flex;
      flex-flow: column nowrap;
      margin-bottom: 16px;

      &--source {
        font-style: italic;
        
        .InfoPanel__value {
          color: #555;
        }
      }

      .InfoPanel__dataLabel {
        margin-bottom: 4px;
        font-weight: 100;
        color: #888;
        font-size: 0.85em;
      }

      .InfoPanel__valueCtn {
        .InfoPanel__value {
          text-transform: inherit;
          font-weight: 200;
          font-size: 0.85em;
        }
      }

      .InfoPanel__data {
        font-family: @font-primary;
        display: flex;
        flex-flow: row nowrap;
        align-items: flex-end;
        font-size: 1.25em;

        > img {
          margin-right: 8px;
          height: 28px;;
        }

        &--lastExecution:not(.InfoPanel__treatyDate--text) {
          font-size: 2em;
          color: @color-primary;
          font-weight: 100;
        }

        .InfoPanel__dataKPI {
          font-size: 1.7em;
          color: @color-primary;
          font-family: @font-primary;
          font-weight: 100;
          margin-right: 4px;
          line-height: 0.8em;
        }
        .InfoPanel__dataDesc {
          font-size: 1em;
          line-height: 0.8em;
          font-weight: 100;
          text-transform: uppercase;
          color: #777;
          font-family: @font-primary;
        }
      }
    }

    .InfoPanel__treatyDate--text {
      color: #222;
      font-size: 1.25em;
    }

    .InfoPanel__activityDesc, .InfoPanel__link {
      font-family: @font-secondary;
      font-size: 0.85em;
      line-height: 1.4em;
      font-weight: 100;
      margin: 0;
    }

    .InfoPanel__moreInfoLinkCtn {
      display: flex;
      flex-flow: row nowrap;
      align-items: flex-start;
      margin: 2px 2px 10px 2px;

      img  {
        margin-right: 8px;
        margin-top: 4px;
      }

      .InfoPanel__link {
        text-decoration: none;
        color: #000;
      }
    }

    .InfoPanel__img {
      max-width: 100%;
    }

    .InfoPanel__newsCtn {
      flex: 1 0 auto;
      max-height: calc(100vh - 215px);

      .News {

        opacity: 0;
        transform: translateY(15px);
        transition: opacity 0.1s linear, transform 10s;

        &:last-child {
          padding-bottom: 0;

          &::after {
            content: "";
            border-left: dashed 1px #ddd;
            height: 10px;
            position: absolute;
            bottom: -10px;
            left: -1px;
          }
        }
      }
    }
    &[data-active="true"] {
      .InfoPanel__newsCtn .News {
        transform: translateY(0);
        opacity: 1;
        transition: transform 0.4s ease-in, opacity 0.3s linear;

        .generate-progressive-delay(20);

        .generate-progressive-delay(@n, @i: 0) when (@i =< @n) {
          &:nth-child(@{i}) { transition-delay: (@i * 0.2s - 0.2s); }
          .generate-progressive-delay(@n, (@i + 1));
        }
      }
    }
  }

  @media screen and (max-width: 640px) {
    .InfoPanel .InfoPanel__newsCtn {
      max-height: calc(100vh - 172px);
    }
  }
</style>
